import { mutateSeniority } from '../../mutations/mutateSeniority';
import { organizationAPI } from 'api/phases/endpoints';

export const removeSeniority = async (seniorityId: number) => {
  await organizationAPI.deleteSeniority(seniorityId);
  await mutateSeniority();
};
